import script from "./UserProfilTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserProfilTable.vue?vue&type=script&lang=ts&setup=true"

import "./UserProfilTable.vue?vue&type=style&index=0&id=7863c829&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7863c829"]])

export default __exports__